import "./popover.scss";

import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";
import { PopoverBody } from "reactstrap";

import NavigationToolbar from "../../components/navigationToolbar";
import { withScreenContext } from "../../components/screen/ScreenContext";
import { isScreenModeMobile } from "../../constants/screenModes";
import { PropTypeShapes } from "../../types";
import { clickWasDropdown } from "../form/utils";
import { popoverOrPortal } from "../portal/popoverOrPortal";

class CalendarPickerPopover extends PureComponent {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.renderPopover = this.renderPopover.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  componentWillMount() {
    this.setState({ popoverOpen: this.props.isOpen });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.state.popoverOpen) {
      this.setState({ popoverOpen: nextProps.isOpen });
    }
  }

  toggle(e) {
    if (!clickWasDropdown(e)) {
      this.props.onOk();
    }
  }

  renderPopover() {
    const { target, children } = this.props;

    let placement = "bottom";
    let hideArrow = true;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right";
// hideArrow = false;
    //#!endif

    let popoverOptions = {
      className: "calendarPickerPopover",
      placement,
      hideArrow,
      isOpen: this.state.popoverOpen,
      target,
      toggle: this.toggle,
      boundariesElement: "viewport"
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggle}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>
          <div className="calendarPickerPopoverContainer">
            <div className="calendarPickerChildren">{children}</div>
          </div>
        </PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    const { disabled } = this.props;

    return this.state.popoverOpen && !disabled ? this.renderPopover() : null;
  }
}

CalendarPickerPopover.propTypes = {
  target: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  children: PropTypeShapes.elementOrArray.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  backText: PropTypes.string,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = CalendarPickerPopover;
//#!if iOS === true
// exportedView = withScreenContext(CalendarPickerPopover);
//#!endif
export default exportedView;
